import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import ElementLocale from 'element-ui/lib/locale'
import mnLocale from 'element-ui/lib/locale/lang/mn'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/tailwind.css'
import './assets/scss/main.scss'
import numpad from './directives/numpad'
import AppFeedback from './plugins/appFeedback'

Vue.config.productionTip = false

// Locale-г Vue.use-аас тусад нь тохируулна (i18n interop алдаа гаргахгүй)
ElementLocale.use(mnLocale)
Vue.use(ElementUI)
Vue.use(AppFeedback)
Vue.directive('numpad', numpad)

new Vue({
  router,
  store,
  data: {
    fullscreenLoading: false,
    img_url: []
  },
  render: h => h(App)
}).$mount('#app')
